import type {
  FulfillmentTypeListRequestType,
  FulfillmentTypeListResponseType,
} from "@sellar-io/api-v2/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useFulfillmentTypeList = <
  TData = FulfillmentTypeListResponseType,
>(
  params: FulfillmentTypeListRequestType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.FulfillmentType,
      params,
    ],
    queryFn: (queryParams) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `fulfillment-type`,
        params: {
          ...params,
          offset: queryParams.pageParam,
        },
      }).then((response) => apiV2AssertResponse<TData>(response).data),
    ...getDefaultInfiniteQueryOptionsV2({
      context: { scope: "businessIfUser", user, business },
      options: { ...options, limit: params.limit },
    }),
  });
};
